'use client';

import numeral from 'numeral';
import useMountedState from 'react-use/lib/useMountedState';
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export type BarChartViewProps = {
  layout?: 'vertical' | 'horizontal';
  data: Object[];
  xDataKey: string;
  bars: BarChartBar[];
};

export type BarChartBar = {
  dataKey: string;
  name?: string;
};

export const BarChartView = ({ data, layout = 'horizontal', xDataKey, bars }: BarChartViewProps) => {
  const isMounted = useMountedState();
  if (!isMounted()) return null;

  return (
    <ResponsiveContainer width="100%" height="100%" minHeight="400px" minWidth="500px">
      <BarChart
        height={300}
        width={500}
        layout={layout}
        data={data}
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <Tooltip />
        <XAxis type="category" dataKey={xDataKey} tickLine={false} width={80} axisLine={false} />
        <YAxis
          type="number"
          tickFormatter={(value: number) => {
            return numeral(value).format('0,0');
          }}
        />
        <Legend formatter={value => <span className="text-foreground">{value}</span>} />
        {bars.map((bar, index) => (
          <Bar
            key={index}
            name={bar?.name || ''}
            dataKey={bar.dataKey}
            fill={`var(--primary${index === 0 || index > 9 ? '' : '-' + index * 300})`}
            radius={[8, 8, 0, 0]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
